<template>
  <svg
    width="32"
    class="custom-icon"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="Frame 166" clip-path="url(#clip0_8999_35574)">
      <g id="Vector">
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M14.7502 2.5L3.24999 2.50014C2.83578 2.50015 2.5 2.83594 2.5 3.25015L2.50012 14.75C2.50013 15.4403 1.94049 16 1.25014 16C0.559782 16 0.000131488 15.4404 0.000124097 14.75L1.92813e-10 3.25018C-1.93117e-05 1.45525 1.45504 0.000162006 3.24996 0.00014019L14.7501 0C15.4405 -8.46376e-06 16.0001 0.559629 16.0001 1.24998C16.0002 1.94034 15.4405 2.49999 14.7502 2.5Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M20.7502 8.5L9.24999 8.50014C8.83578 8.50014 8.5 8.83594 8.5 9.25015L8.50012 20.75C8.50013 21.4403 7.94049 22 7.25014 22C6.55978 22 6.00013 21.4403 6.00012 20.75L6 9.25018C5.99998 7.45525 7.45504 6.00016 9.24996 6.00014L20.7501 6C21.4405 5.99999 22.0001 6.55963 22.0001 7.24998C22.0002 7.94034 21.4405 8.49999 20.7502 8.5Z"
        />
        <path
          fill-rule="evenodd"
          clip-rule="evenodd"
          d="M16 12C13.7909 12 12 13.7909 12 16V28C12 30.2091 13.7909 32 16 32H28C30.2091 32 32 30.2091 32 28V16C32 13.7909 30.2091 12 28 12H16ZM26 22.866C26.6667 22.4811 26.6667 21.5189 26 21.134L20 17.6699C19.3333 17.285 18.5 17.7661 18.5 18.5359V25.4641C18.5 26.2339 19.3333 26.715 20 26.3301L26 22.866Z"
        />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_8999_35574">
        <rect width="32" height="32" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
